import React from 'react';
import { OrderDetailsResponseDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import CancelAndSaveButtons from 'commons/components/CancelAndSaveButtons';
import { InterfaceNameBooleanValue, InterfaceNameValue } from 'commons/types';
import { RefundAmountSelectorCard, RefundConfigurationsCard } from '../';
import useTranslationOrders from '../../../../../useTranslationOrders';
import { RefundAttributes } from '../../../hooks/useRefundOrder/useRefundOrder';
import { UseRefundStepsResult } from '../../hooks/useSteps';

interface Attributes {
  orderDetails: OrderDetailsResponseDto;
  values: RefundAttributes;
  onChange: (data: InterfaceNameValue | InterfaceNameBooleanValue) => void;
  useSteps: UseRefundStepsResult;
  disableButton: () => boolean;
  disableCancelOrderCheckbox: boolean;
}

function SetUpRefundDetailsPage({
  orderDetails,
  values,
  onChange,
  useSteps,
  disableButton,
  disableCancelOrderCheckbox,
}: Attributes): React.JSX.Element {
  const t = useTranslationOrders();

  return (
    <Stack column align="stretch">
      <RefundAmountSelectorCard
        order={orderDetails}
        values={values}
        onChange={onChange}
      />
      <RefundConfigurationsCard
        values={values}
        onChange={onChange}
        disableCancelOrderCheckbox={disableCancelOrderCheckbox}
      />
      <Stack justify="flex-end">
        <CancelAndSaveButtons
          saveText={t('refund.setUpRefundDetails.buttons.save')}
          cancelText={t('refund.setUpRefundDetails.buttons.cancel')}
          onSave={useSteps.nextStep}
          onCancel={useSteps.backStep}
          isDisabled={disableButton()}
        />
      </Stack>
    </Stack>
  );
}

export default SetUpRefundDetailsPage;
